export default __webpack_public_path__ + "static/media/about-photo.b5812ed6.jpg";